import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import { updateObjectInArray } from "../../shared/utility";
import DocumentDetailsForm from "../../components/forms/documents/DocumentDetailsForm";

export function DocumentsViewModel(logout) {
  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState({
    data: [],
  });
  const [successNotification, setSuccessNotification] = useState({
    show: false,
    title: "",
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const user_id = localStorage.getItem("id") * 1;

  const getDocuments = async function (search, page) {
    setLoading(true);
    const authData = {
      action: "fetchDocuments",
      userId: 1,
      search: search,
      pageNumber: page,
    };
    let callResult = await makePostApiCall(authData);
    setLoading(false);
    if (callResult.success) {
      setDocuments(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createDocument = async function (values) {
    const payload = {
      ...values,
      action: "createDocument",
      user_id: user_id,
    };
    let callResult = await makePostApiCall(
      payload,
      "multipart/form-data",
      "documents/document/createDocument.php"
    );

    if (callResult.success) {
      setSlideOver({
        childComponent: null,
        open: false,
      });
      if (callResult.data.status == "overwrite") {
        // TODO OGGY
        console.log("in overwrite");
      } else {
        setSuccessNotification({
          show: true,
          title: "Document added",
        });
        getDocuments(null, 0);
      }
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddDocumentSlideOver = () => {
    setSlideOver({
      childComponent: (
        <DocumentDetailsForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createDocument}
        />
      ),
      open: true,
    });
  };

  const editDocument = async function (values, index) {
    const payload = {
      ...values,
      action: "editDocument",
      user_id: user_id,
    };
    let callResult = await makePostApiCall(
      payload,
      "multipart/form-data",
      "documents/document/editDocument.php"
    );
    if (callResult.success) {
      const currentDocuments = [...documents.data];
      const updateDocument = {
        ...values,
      };

      const updatePayload = {
        index: index,
        item: updateDocument,
      };

      const updatedDocuments = updateObjectInArray(
        currentDocuments,
        updatePayload
      );

      const newDocuments = { ...documents, data: updatedDocuments };

      setDocuments(newDocuments);
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setSuccessNotification({
        show: true,
        title: "Document updated",
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openEditDocumentSlideOver = (document, index) => {
    setSlideOver({
      childComponent: (
        <DocumentDetailsForm
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          document={document}
          actionCall={editDocument}
        />
      ),
      open: true,
    });
  };

  return {
    getDocuments,
    loading,
    documents,
    openAddDocumentSlideOver,
    openEditDocumentSlideOver,
    setSlideOver,
    slideOver,
    setSuccessNotification,
    successNotification,
  };
}
